import { useState } from 'react';

// =====================================================================
// ComboBusca — lista suspensa que TAMBÉM aceita digitação para filtrar.
//
// Parece um <select> comum, mas resolve o problema dele: com centenas de
// opções, um <select> puro só deixa ROLAR — não dá para procurar. Aqui, ao
// focar mostra a lista inteira; digitando, filtra por trecho e sem acento
// (digitar "jose" acha "JOSÉ").
//
// Nasceu dentro de `manutencao/certificacao/SelecaoPecaCentral.js` (pedido da
// Julia em 2026-07-03, para as ~840 peças da Central de Pedidos) e foi extraído
// para cá em 2026-07-28, quando o formulário de Atestados precisou do mesmo
// comportamento no seletor de funcionário. Comportamento idêntico ao original.
//
// `opcoes` = [{ key, label, valor }] — `label` é o que aparece e o que o filtro
// pesquisa; `valor` é o que volta no onMudar.
// =====================================================================

// Comparação sem acento/caixa para o filtro digitado (ABRAÇADEIRA casa "abracadeira").
// Sem regex de combinantes de propósito — o range literal é frágil no editor.
export const semAcento = (s) => [...String(s || '').normalize('NFD')]
  .filter((ch) => ch.charCodeAt(0) < 0x300 || ch.charCodeAt(0) > 0x36f)
  .join('').toLowerCase();

const estiloPadrao = {
  width: '100%', padding: 8, border: '1px solid #cbd5e1',
  borderRadius: 6, boxSizing: 'border-box',
};

const ComboBusca = ({ valor, placeholder, opcoes, onMudar, style, className, required = false }) => {
  const [texto, setTexto] = useState('');
  const [aberto, setAberto] = useState(false);
  const filtradas = texto ? opcoes.filter((o) => semAcento(o.label).includes(semAcento(texto))) : opcoes;

  return (
    <div style={{ position: 'relative' }}>
      <input
        className={className}
        style={style || estiloPadrao}
        placeholder={placeholder}
        // Na hora do submit o campo não está focado, então o `value` abaixo é a
        // opção escolhida — o `required` do HTML barra o envio em branco igual
        // ao <select> que este componente substituiu.
        required={required}
        // Enquanto a lista está aberta o campo vira caixa de busca (mostra o que
        // foi digitado); fechada, volta a exibir a opção escolhida.
        value={aberto ? texto : (valor || '')}
        onFocus={() => { setAberto(true); setTexto(''); }}
        onBlur={() => setAberto(false)}
        onChange={(e) => setTexto(e.target.value)}
      />
      {aberto && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, background: '#fff',
          border: '1px solid #cbd5e1', borderRadius: 6, maxHeight: 240, overflowY: 'auto',
          boxShadow: '0 4px 12px rgba(0,0,0,.08)',
        }}>
          {filtradas.length === 0 && (
            <div style={{ padding: 8, fontSize: 12, color: '#94a3b8' }}>Nada encontrado para "{texto}".</div>
          )}
          {/* onMouseDown (não onClick): dispara ANTES do blur do input fechar a lista. */}
          {filtradas.map((o) => (
            <div key={o.key} onMouseDown={() => { onMudar(o.valor); setAberto(false); }}
              style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13, borderBottom: '1px solid #f1f5f9' }}>
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComboBusca;
